import { FC } from "react"
import { MainLayout } from "./MainLayout"

export const OrdersPage: FC = () => {
  return <MainLayout>orders page</MainLayout>
}
